import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { RoundedProgressBar } from './components/RoundedProgressBar'
import { AdaptedSavingGoalDTO } from '@/domain/transfer'

interface SavingItemProps {
  saving: AdaptedSavingGoalDTO
  onPress: (saving: AdaptedSavingGoalDTO) => void
}

export const SavingItem: React.FC<SavingItemProps> = ({ saving, onPress }) => {
  const { t } = useTranslation()
  const {
    category,
    stakedMaskedStableCoinAsFiat,
    current_apy,
    goal_percentage,
  } = saving

  const handlePress = () => {
    onPress(saving)
  }

  return (
    <BaseView
      row
      align="center"
      justify="space-between"
      px={20}
      py={10}
      bgColor="background.cardItemRoot"
      rounded={32}
      style={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      onClick={handlePress}
    >
      {/* Left Content */}
      <BaseView style={{ flex: 1 }}>
        {/* Total Saved Label */}
        <BaseText fontSize={15} fontFamily="semibold" color="label.default">
          {t('translation:goal.totalSaved')}
        </BaseText>

        {/* Amount and APY */}
        <BaseView>
          <BaseText fontSize={26} fontFamily="semibold" color="label.default">
            {stakedMaskedStableCoinAsFiat}
          </BaseText>

          <BaseText
            fontSize={15}
            fontFamily="regular"
            color="label.description"
          >
            {current_apy}% APY
          </BaseText>
        </BaseView>
      </BaseView>

      {/* Right Content - Progress Bar */}
      <RoundedProgressBar
        percentage={Number(goal_percentage)}
        text={category}
        size={92}
        strokeWidth={7}
      />
    </BaseView>
  )
}
